import { getField, updateField } from "vuex-map-fields";
import Repository from "@/repository";

const COMMENT_API = "/comment";

// ----------------------- STATE ------------------------- //
const state = {
  comment_data: [],
  currentIndex: -1
};

// ----------------------- GETTERS ----------------------- //
const getters = {
  getComment: state => getField(state.comment_data[state.currentIndex]),

  getCurrentComment: state => {
    return state.comment_data[state.currentIndex];
  },
  getLastComments: state => maxItems => {
    if (state.comment_data.length > maxItems - 1) {
      return state.comment_data.slice(0, maxItems);
    } else {
      return state.comment_data;
    }
  }
};

// ----------------------- MUTATIONS -------------------- //
const mutations = {
  updateComment(state, payload) {
    updateField(state.comment_data[state.currentIndex], payload);
  },

  setCurrentIndexByID(state, theID) {
    state.currentIndex = state.comment_data.findIndex(
      comment => comment.id == theID
    );
  },

  loadAllComments(state, payload) {
    state.comment_data = payload.data;
    state.currentIndex = 0;
  },

  addComment(state, payload) {
    state.comment_data.unshift(payload.data);
    state.currentIndex = state.comment_data.length - 1;
  },

  saveComment(state, payload) {
    state.comment_data[state.currentIndex] = payload.data;
  },

  fetchComment(state, payload) {
    if (state.currentIndex == -1) {
      state.comment_data.push(payload.data);
      state.currentIndex = 0;
    } else {
      state.comment_data[state.currentIndex] = payload.data;
    }
  },

  fetchCommentListByReference(state, payload) {
    if (payload.data.length > 0) {
      state.currentIndex = 0;
    }
    state.comment_data = payload.data;
  },

  deleteComment(state, payload) {
    state.currentIndex = state.comment_data.findIndex(
      comment => comment.id == payload.data.id
    );
    state.comment_data.splice(state.currentIndex, 1);
    state.currentIndex = 0;
  },
  reset(state) {
    state.comment_data = []
    state.currentIndex = -1
  }
};

// ----------------------- ACTIONS -------------------- //
const actions = {
  async loadAllComments({ commit }) {
    try {
      commit("loadAllComments", await Repository.get(`${COMMENT_API}`));
    } catch (error) {
      console.log(error);
    }
  },

  async addComment({ commit }, payload) {
    await Repository.post(`${COMMENT_API}/new`, payload)
      .then(response => {
        commit("addComment", response);
      })
      .catch(error => {
        console.log(error);
      });
  },

  async saveComment({ state, commit }) {
    try {
      commit(
        "saveComment",
        await Repository.post(
          `${COMMENT_API}`,
          state.comment_data[state.currentIndex]
        )
      );
    } catch (error) {
      console.log(error);
    }
  },

  async fetchComment({ commit }, payloadID) {
    try {
      commit(
        "fetchComment",
        await Repository.get(`${COMMENT_API}/${payloadID}`)
      );
    } catch (error) {
      console.log(error);
    }
  },

  async fetchCommentListByReference({ commit }, referenceID) {
    try {
      console.log(`${COMMENT_API}/reference/${referenceID}`);
      commit(
        "fetchCommentListByReference",
        await Repository.get(`${COMMENT_API}/reference/${referenceID}`)
      );
    } catch (error) {
      console.log(error);
    }
  },

  async deleteComment({ commit }, payloadID) {
    try {
      commit(
        "deleteComment",
        await Repository.delete(`${COMMENT_API}/${payloadID}`)
      );
    } catch (error) {
      console.log(error);
    }
  },

  async searchComments({ commit }, searchTerm) {
    try {
      commit(
        "loadAllComments",
        await Repository.get(`${COMMENT_API}/search?q=${searchTerm}`)
      );
    } catch (error) {
      console.log(error);
    }
  }
};
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
